export default "__VITE_ASSET__0400bc2b__"